import React, { Component } from 'react';
import IconCheckmarkImage from "../../../../icons/icon-checkmark.svg";
import { submitForm, phoneRegX, emailRegX } from './submitForm';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import '../../../../sass/material.scss';
import { navigate } from 'gatsby';

export default class FormSection extends Component {
  constructor(props) {
    super(props);
    this.nameRef = React.createRef();
    this.referrer = null;
    this.state = {
      name: "",
      nameValidation: "",
      phone: "",
      phoneValidation: "",
      email: "",
      emailValidation: "",
      message: "",
      messageValidation: "",
      shouldSubmit: false,
      showSuccess: false,
      submitButtonState: ""
    };
  }

  clearFields = () => {
    this.setState({
      name: "",
      nameValidation: "",
      phone: "",
      phoneValidation: "",
      email: "",
      emailValidation: "",
      message: "",
      messageValidation: "",
      shouldSubmit: false,
      showSuccess: false,
      submitButtonState: ""
    });
  };

  componentDidUpdate() {
    this.props.isVisible && this.nameRef.current.focus();
    this.referrer = document.referrer;
  }

  checkFields = () => {
    const { nameValidation, emailValidation, phoneValidation, messageValidation } = this.state;
    if (nameValidation === 'success-field' &&
      emailValidation === 'success-field' &&
      phoneValidation === 'success-field' &&
      messageValidation === 'success-field') {
      this.setState({
        shouldSubmit: true
      });
    }
    return {
      ...(!nameValidation) && { nameValidation: 'error-field', shouldSubmit: false },
      ...(!emailValidation) && { emailValidation: 'error-field', shouldSubmit: false },
      ...(!phoneValidation) && { phoneValidation: 'error-field', shouldSubmit: false },
      ...(!messageValidation) && { messageValidation: 'error-field', shouldSubmit: false },
    };
  };

  onSubmit = (event) => {
    event.preventDefault();
    if (this.state.submitButtonState === '') {
      this.setState(this.checkFields(),
        async () => {
          if (this.state.shouldSubmit) {
            this.setState({
              submitButtonState: "inProgress"
            });
            const requestData = {
              method: "post",
              url: "https://rapidopsbackend.kinsta.cloud/wp-json/gf/v2/entries",
              data: {
                "form_id": "4",
                "1": this.state.name,
                "2": this.state.phone,
                "3": this.state.email,
                "4": this.state.message,
                "5": this.referrer,
                "6": this.props.location.pathname
              },
            };
            try {
              const response = await submitForm(requestData);
              if (response.status === 201) {
                setTimeout(() => {
                  this.setState({
                    submitButtonState: "finished"
                  });
                }, 600);
              }
              setTimeout(() => {
                this.clearFields();
                navigate('/thank-you');
              }, 1000);
            } catch (error) {
              setTimeout(() => {
                this.setState({
                  submitButtonState: "finished"
                });
              }, 1200);
            }

          }
        });
    }
  };


  handleChange = (e) => {
    const name = e.target ? e.target.name : 'phone';
    const value = e.target ? e.target.value : e;
    switch (name) {
      case 'name':
        if (!value)
          this.setState({
            nameValidation: 'error-field',
            shouldSubmit: false,
          });
        else
          this.setState({
            nameValidation: 'success-field',
          });
        break;

      case 'phone':
        if (!value)
          this.setState({
            phoneValidation: 'error-field',
            shouldSubmit: false,
          });
        else
          this.setState({
            phoneValidation: 'success-field',
          });
        break;

      case 'email':
        if (!emailRegX.test(value))
          this.setState({
            emailValidation: 'error-field',
            shouldSubmit: false,
          });
        else
          this.setState({
            emailValidation: 'success-field',
          });
        break;


      case 'message':
        if (value.length < 5)
          this.setState({
            messageValidation: 'error-field',
            shouldSubmit: false,
          });
        else
          this.setState({
            messageValidation: 'success-field',
          });
        break;

      default:
        break;
    }
    const newState = {};
    newState[name] = value;
    this.setState(newState);
  };

  render() {
    const { nameValidation, emailValidation, phoneValidation, messageValidation, showSuccess, submitButtonState } = this.state;
    return (
      <div className="form-section" id={this.props.id ? this.props.id : "form-section"}>
        {!showSuccess &&
          <div className="container">
            <h5 className="form-title h3">Say hello to us!</h5>
            <form name="contact" onSubmit={this.onSubmit} className="fomt-style-fancy">
              <div className="form-row has-three-column">
                <div className="form-column">
                  <input ref={this.nameRef} placeholder="Name" type="text" className={`form-input LoNotSensitive ${nameValidation}`} id="name" name="name" autoComplete="off" onChange={this.handleChange} value={this.state.name} tabIndex="1" />
                </div>
                <div className="form-column">
                  <PhoneInput
                    country='us'
                    preferredCountries={['us', 'in', 'ca', 'de', 'au', 'gb']}
                    preserveOrder={['preferredCountries']}
                    enableSearch
                    placeholder="Phone*"
                    inputClass={phoneValidation}
                    id="phone"
                    name="phone"
                    value={this.state.phone}
                    onChange={this.handleChange}
                    inputProps={{ tabIndex: "2" }} />
                </div>
                <div className="form-column">
                  <input placeholder="Email" type="email" name="email" className={`form-input LoNotSensitive ${emailValidation}`} id="email" autoComplete="off" onChange={this.handleChange} value={this.state.email} tabIndex="3" />
                </div>
              </div>
              <div className="form-row">
                <div className="form-column">
                  <textarea placeholder="Tell about your project" rows="4" name="message" className={`form-input textarea-small ${messageValidation}`} id="message" cols="20" autoComplete="off" onChange={this.handleChange} value={this.state.message} tabIndex="4" />
                </div>
              </div>
              <div className="form-action">
                <button type="submit" className={`button right-arrow ${submitButtonState}`} tabIndex="5" >
                  <span className="submit">Get Started</span>
                  <span className="loading"> loading </span>
                  <span className="check"> <IconCheckmarkImage /> </span>
                </button>
                <p>By clicking the button, you consent on the processing of personal data.</p>
              </div>
            </form>
          </div>
        }
        {showSuccess &&
          <div className="section-title">
            <div className="container">
              <h2>Thank you</h2>
              <p>{this.confMessage}</p>
            </div>
          </div>
        }
      </ div>
    );
  }
}